import { Injectable } from "@angular/core";

import { parseList } from "@helpers/functions";
import { SocketService } from "../socket.service";
import { CryptoTransactionNotifyService } from "../notify/crypto_transaction.notify.service";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";
import { DerivativeWalletService } from "./derivative_wallet.service";
import { StockWallet } from "@models/derivative/wallets/stock_wallet";
import { Stock } from "@models/derivative/currencies/stock";
import { STOCK_TRANSACTIONS_ROOM, STOCK_WALLETS_ROOM } from "@helpers/constants";
import { StockService } from "../currency/stock.service";
import { DerivativeTransaction } from "@models/transaction";
import { GetPendingTradesGQLService } from "@gql/offer";
import { ApicallService } from "@core-services/apicall.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";

const name = ServiceNames.STOCK_WALLET;

@Injectable({
	providedIn: "root"
})
export class StockWalletService extends DerivativeWalletService<StockWallet, Stock> {
	public name: string = ServiceNames.STOCK_WALLET;

	public TxType = DerivativeTransaction;
	public WalletType = StockWallet;

	protected transactionSocketRoomName: string = STOCK_TRANSACTIONS_ROOM;
	protected walletSocketRoomName: string = STOCK_WALLETS_ROOM;

	public constructor(
		protected currencyService: StockService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected initService: InitService,
		protected transactionNotifyService: CryptoTransactionNotifyService,
		protected destructor: DestructorService,
		protected getPendingTradesGQLService: GetPendingTradesGQLService
	) {
		super(initService, destructor, name, getPendingTradesGQLService);
	}

	public getCanCreateMore(): boolean {
		return this.canCreateMore;
	}

	public getCannotCreateReason(): string {
		return this.cannotCreateReason;
	}

	public getParseData(wallets): StockWallet[] {
		if (!wallets || !wallets["attributes"]["stock"]) {
			return [];
		}
		return parseList(wallets["attributes"]["stock"]["attributes"]["wallets"], StockWallet);
	}
}
